import { LOADER } from '../actions/types'

const initialState = false;

export default (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case LOADER.MOSTRAR:
            return true;

        case LOADER.OCULTAR:
            return false;

        default:
            return state;
    }
}